import {BaseContainerModel} from '../base-container.model';
import {app_mst_link_subject_to_grp_RowClass} from '../../dbschema';

export class LinkSubjectToGroupContainerModel extends BaseContainerModel {
  link_subject_to_grp: app_mst_link_subject_to_grp_RowClass = new app_mst_link_subject_to_grp_RowClass();
}
